<template>
    <div class="container py-5">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th colspan="7" class="text-center">{{ $t('tables') }}</th>
                </tr>
                <tr>
                    <td colspan="7" style="padding:0">
                        <input class="form-control" style="border:none" :placeholder="$t('filterByName')" v-model="filterInput" type="search">
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('creationType') }}</th>
                    <th class="text-end">{{ $t('rows') }}</th>
                    <th class="text-end">{{ $t('size') }}</th>
                    <th>{{ $t('updatedBy') }}</th>
                    <th>{{ $t('updatedDate') }}</th>
                    <th class="text-end"></th>
                </tr>
            </thead>
            <tbody v-if="filteredTables.length > 0">
                <tr v-for="item in filteredTables" :key="item.id">
                    <td class="table-name">{{ item.name }}</td>
                    <td>
                        <span class="badge-type">{{ getBatchLabel(item) }}</span>
                    </td>
                    <td class="text-end">{{ formatNumber(item.rowCount) }}</td>
                    <td class="text-end">{{ formatSize(item.sizeMB) }}</td>
                    <td>{{ item.reimportedBy || item.createdBy }}</td>
                    <td>{{ this.getDate(item) }}</td>
                    <td class="text-end">
                        <button type="button" class="btn  btn-sm text-secondary" @click="reimportTable(item)" :title="$t('reimport')" >
                            <i class="fas fa-sync-alt"></i>
                        </button>
                        <div class="dropdown d-inline-block">
                            <button type="button" class="btn  btn-sm text-secondary" data-bs-toggle="dropdown" :title="$t('export')" >
                                <i class="fas fa-download"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li>
                                    <button type="button" class="dropdown-item" @click="exportCsv(item)" >
                                        <i class="fas fa-file-csv fa-fw me-2"></i>
                                        CSV
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="dropdown-item" @click="exportShp(item)">
                                        <i class="fas fa-map fa-fw me-2"></i>
                                        SHP
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <button type="button" class="btn btn-sm text-secondary delete-action" @click="showDeleteTable(item)" :title="$t('delete')">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="7">{{ $t('noTables') }}</td>
                </tr>
            </tbody>
        </table>

        <button class="btn btn-primary" @click="showImport = true">{{ $t('import') }}</button>

        <ImportModal v-if="showImport" :dataSpaceId="dataSpaceId" @imported="onImported" @close="showImport = false" />
        <TableDeleteModal v-if="showDeleteTableModal" :data="dataSpaceId" @reload="loadTables" @close="showDeleteTableModal = false" />
        <ReimportModal v-if="showReimport && reimportItem" :table="reimportItem" @reload="loadTables()" @close="closeReimport" />
        <ExportModal v-if="showExport && exportTableItem" :table="exportTableItem" :dataSpaceId="$route.params.id" @close="showExport = false" />
    </div>
</template>

<script>
    import ImportModal from './ImportModal.vue';
    import dataspaceApi from '../../api/server/dataspace';
    import TableDeleteModal from './TableDeleteModal.vue';
    import ReimportModal from './ReimportModal.vue';
    import ExportModal from './ExportModal.vue';

    import moment from 'moment';

    export default {
        name: 'Tables',
        components: { ImportModal, TableDeleteModal, ReimportModal, ExportModal },
        
        data() {
            return {
                tables: [],
                filterInput: '',
                showImport: false,
                showDeleteTableModal: false,
                tableToDeleteName: "",
                showReimport: false,
                reimportItem: null,
                exportTableItem: null,
                showExport: false
            };
        },
        mounted() {
            this.loadTables();
        },
        computed: {
            dataSpaceId() {
                return this.$route.params.id; 
            },
            filteredTables() {
                if (!this.filterInput)
                    return this.tables;

                const filter = this.filterInput.toLowerCase();
                return this.tables.filter(t => t.name.toLowerCase().includes(filter));
            }
        },
        methods: {
            async loadTables() {
                this.showDeleteTableModal = false;
                this.tables = await dataspaceApi.tables(this.$route.params.id);
            },
            exportCsv(item) {
                var request = dataspaceApi.tableExport(this.$route.params.id, item.name)
                window.open(request.url);
            },
            exportShp(item) {
                this.exportTableItem = item;
                this.showExport = true;
            },
            exportItem(item) {
                this.exportTableItem = item;
                this.showExport = true;
            },
            onImported() {
                this.showImport = false;
                this.loadTables();
            },
            showDeleteTable(item) {
                this.tableToDeleteName = item.name
                this.showDeleteTableModal = true
            },
            getDate(item) {
                var finalDate = item.reimportedDate;
                if(!finalDate)
                    finalDate = item.createdDate;

                return moment(finalDate).format("DD.MM.YYYY HH:mm");
            },
            getBatchLabel(item) {
                var result = "";
                if(item.batchName)
                    result = item.batchName + " - " + item.origin
                else 
                    result = item.origin;

                return result;
            },
            formatSize(mb) {
                if (mb == null) 
                    return "";
                var val = Math.max(1, Math.round(mb));
                return val.toLocaleString('cs-CZ') + ' MB';
            },

            formatNumber(num) {
                if (num == null) 
                    return "";
                return num.toLocaleString('cs-CZ');
            },
            reimportTable(item) {
                this.reimportItem = item;
                this.showReimport = true;
            },
            closeReimport() {
                this.showReimport = false;
                this.reimportItem = null;
            },
        }
    };
</script>